export const INITIALIZE_BUSINESS_PAGE = 'initialize-business-page';
const initializeBusinessPage = () => ({ type: INITIALIZE_BUSINESS_PAGE });
export default initializeBusinessPage;
